import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DoubleCounter from 'components/shared/counters/double/DoubleCounter';
import Emoji from 'components/shared/Emoji';
import routes from 'common/routes';

function SessionStatusCounters() {
  const { t } = useTranslation(['sessions']);
  const navigate = useNavigate();

  const finishedThisMonthSessionsCounter = useSelector(
    (state) => state.session.counters.finishedThisMonth
  );
  const absentThisMonthSessionsCounter = useSelector(
    (state) => state.session.counters.absentThisMonth
  );

  return (
    <DoubleCounter
      emoji={<Emoji label={t('sessionStatus', { ns: 'sessions' })} symbol="📅" />}
      title={t('monthlySessionStatus', { ns: 'sessions' })}
      onClick={() => navigate(routes.listSession.path)}
      counters={[
        {
          title: t('finished', { ns: 'sessions' }),
          counter: finishedThisMonthSessionsCounter
        },
        {
          title: t('absent', { ns: 'sessions' }),
          counter: absentThisMonthSessionsCounter
        }
      ]}
    />
  );
}

export default SessionStatusCounters;
